export default "__VITE_ASSET__CLZCa40a__"